// extracted by mini-css-extract-plugin
module.exports = {"shimmer":"Icon_shimmer__3S9JI"};